// extracted by mini-css-extract-plugin
export default {"submitBtn":"submitBtn__9yJOl","rectangle":"rectangle__UeJRa"};